import React from "react"
import PropTypes from "prop-types"
import classnames from "classnames"
import TextAreaAutoSize from "react-textarea-autosize"

import styles from "./../inputs.less"

const TextAreaResizable = (props) => {
  const { notValid, scrollable, ...restProps } = props
  const inputClass = classnames(styles.textarea, props.className, {
    disabled: props.disabled,
    [styles.notValid]: props.notValid,
    [styles.scrollable]: props.scrollable,
  })

  return <TextAreaAutoSize {...restProps} data-qa={props.dataQa} className={inputClass} />
}

TextAreaResizable.propTypes = {
  disabled: PropTypes.bool,
  notValid: PropTypes.bool,
  scrollable: PropTypes.bool,
  ...TextAreaAutoSize.propTypes,
}

TextAreaResizable.defaultProps = {
  disabled: false,
  notValid: false,
  scrollable: false,
  ...TextAreaAutoSize.defaultProps,
}

export default TextAreaResizable
